import { StarFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';

export function ProdutoFavoritoIcone({
    pro_favorito,
}: {
    pro_favorito: number | null | undefined;
}) {
    if (pro_favorito === 1) {
        return (
            <Tooltip title='Produto favorito'>
                <StarFilled aria-label='Produto favorito' className='text-xs text-yellow-500' />
            </Tooltip>
        );
    }

    return null;
}
